import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaTwitter, FaNpm, FaDev, FaCodepen } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  const socialLinks = [
    { icon: <FaDev />, url: 'https://dev.to/mahmud-r-farhan' },
    { icon: <FaLinkedin />, url: 'https://linkedin.com/in/mahmud-r-farhan' },
    { icon: <FaTwitter />, url: 'https://x.com/mahmud_r_farhan' },
   

  ];

  const contributions = [
    { icon: <FaNpm />, url: 'https://www.npmjs.com/~conflow' },
    { icon: <FaGithub />, url: 'https://github.com/mahmud-r-farhan' },
    { icon: <FaCodepen />, url: 'https://codepen.io/mahmud-r-farhan' },
  ]

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white relative overflow-hidden">
      {/* Tech-inspired background patterns */}
      <div className="absolute inset-0 opacity-5">
        <div className="grid grid-cols-12 gap-4 h-full">
          {[...Array(48)].map((_, i) => (
            <motion.div
              key={i}
              className="h-2 bg-blue-400"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1, delay: i * 0.1 }}
            />
          ))}
        </div>
      </div>

      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
              <img src='https://res.cloudinary.com/dqovjmmlx/image/upload/v1735399674/logo_eb7jec.png' className='w-14 h-14'></img>
            <p className="text-gray-300">
              Full Stack MERN Developer crafting digital experiences
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {links.map((link) => (
                <motion.li
                  key={link.name}
                  whileHover={{ x: 5 }}
                >
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div> 

           {/* Navigation */}
           <div>
            <h4 className="text-xl font-semibold mb-4">Contributions</h4>
            <ul className="flex space-x-4">
              {contributions.map((social, index) => (
                <motion.a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -5 }}
                className="text-gray-300 hover:text-blue-400 text-2xl transition-colors"
              >
                {social.icon}
              </motion.a>
              ))}
            </ul>
          </div> 

          {/* Social Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -5 }}
                  className="text-gray-300 hover:text-blue-400 text-2xl transition-colors"
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        
              
        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>© {currentYear} devplus.fun</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
